module.exports = __webpack_public_path__ + "static/media/blocks1.1e628faa.svg";